// frontend/src/components/Common/NotificationBell/NotificationItem.jsx

import React from 'react';
import { useTranslation } from '../../../context/TranslationContext';
import * as FiIcons from 'react-icons/fi';
import { FiTrash2 } from 'react-icons/fi';
import './NotificationBell.css';

const NotificationItem = ({ notification, onClick, onDelete }) => {
  const { t } = useTranslation();

  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return t('comments.just_now', 'Just now');
    if (diffMins < 60) return `${diffMins}${t('comments.min_ago', 'm ago')}`;
    if (diffHours < 24) return `${diffHours}${t('comments.hour_ago', 'h ago')}`;
    if (diffDays < 7) return `${diffDays}${t('comments.day_ago', 'd ago')}`;
    
    return date.toLocaleDateString();
  };

  const getIconComponent = (iconName) => {
    if (!iconName) return FiIcons.FiBell;
    
    const iconKey = iconName.startsWith('Fi') ? iconName : `Fi${iconName}`;
    const Icon = FiIcons[iconKey] || FiIcons.FiBell;
    
    return Icon;
  };

  // Title and message are stored in the user's language in the DB — display directly.
  const getTranslatedTitle   = () => notification.title   || 'Notification';
  const getTranslatedMessage = () => notification.message || '';

  if (!notification) return null;

  const IconComponent = getIconComponent(notification.icon);
  const translatedTitle   = getTranslatedTitle();
  const translatedMessage = getTranslatedMessage();

  return (
    <div 
      className={`notification-item ${!notification.is_read ? 'notification-item-unread' : ''}`}
      onClick={onClick}
      style={{ cursor: notification.entity_url ? 'pointer' : 'default' }}
    >
      {/* Icon */}
      <div 
        className="notification-icon-minimal"
        style={{ color: notification.color || '#3b82f6' }}
      >
        <IconComponent size={20} />
      </div>

      {/* Content */}
      <div className="notification-content">
        <div className="notification-title">{translatedTitle}</div>
        {translatedMessage && (
          <div className="notification-message">{translatedMessage}</div>
        )}
        <div className="notification-meta">
          <span className="notification-time">{formatDate(notification.created_at)}</span>
          {notification.created_by_name && (
            <span className="notification-creator">by {notification.created_by_name}</span>
          )}
        </div>
      </div>

      {/* Actions: delete */}
      <div className="notification-actions">
        {onDelete && (
          <button
            className="notif-delete-btn"
            title="Remover"
            onClick={e => {
              e.stopPropagation();
              onDelete(notification.notification_id);
            }}
          >
            <FiTrash2 size={13} />
          </button>
        )}
      </div>

      {/* Unread indicator */}
      {!notification.is_read && (
        <div className="notification-unread-dot" />
      )}
    </div>
  );
};

export default NotificationItem;